var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#006AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6787 45.4915V18.8675H33.5776V45.4915H30.6787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4354 27.7377L36.4826 30.1121L34.4861 20.8193L37.1482 20.2177L38.1977 24.6209C38.1977 24.6209 40.6166 20.6529 37.3914 16.5441C35.4907 14.4321 34.5885 14.3425 32.4574 14.0097C30.5825 13.7409 26.2245 14.3745 24.9254 19.4625C24.375 22.7393 24.9958 25.1649 29.2194 28.3393L28.9826 31.8721C28.9826 31.8721 24.2663 28.5505 23.0503 26.2209C22.1097 24.3777 20.497 20.7361 23.4087 15.6673C24.9766 13.133 28.0675 10.701 33.5134 10.957C36.2523 11.0722 42.9395 14.4193 41.9029 22.2401C41.7237 23.7057 40.9622 25.6577 40.9622 25.6577L44.6354 24.8385L45.4354 27.7377Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3222 48.5699C38.6839 51.0595 35.5291 53.4083 30.0961 53.0115C27.3571 52.8259 20.7658 49.2995 22.0073 41.5107C22.2249 40.0515 23.0375 38.1251 23.0375 38.1251L19.3451 38.8419L18.6221 35.9299L27.6387 33.7923L29.3921 43.1363L26.7107 43.6675L25.7765 39.2323C25.7765 39.2323 23.2551 43.1299 26.3653 47.3283C28.2082 49.4915 29.1042 49.6003 31.2351 49.9907C33.0974 50.3107 37.4745 49.7859 38.9079 44.7363C39.5415 41.4787 38.9847 39.0339 34.8507 35.7443L35.1835 32.2179C35.1835 32.2179 39.8103 35.6611 40.9622 38.0227C41.8453 39.8979 43.3619 43.5843 40.3222 48.5699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/t2.f40fe74034e2e05cb5fdc7558ad48908.svg";
export { ForwardRef as ReactComponent };